module.exports = __webpack_public_path__ + "media/images/emblems/Hildisrieden_LU-22c0288881e946000f27dfc3172b21db.png";